import { h, Host, getAssetPath } from "@stencil/core";
export class ChStepListItem {
    constructor() {
        this.iconSrc = undefined;
    }
    /**
     * Emits the item id
     */
    itemClicked;
    el;
    ulStepItem;
    itemClickedHandler(item) {
        const targetItem = item.el.innerText;
        this.setActiveOption(targetItem);
        this.itemClicked.emit({ "item-clicked": targetItem });
    }
    setActiveOption(targetItem) {
        const parent = this.el.parentElement;
        const stepItems = parent.children;
        for (let i = 0; i < stepItems.length; i++) {
            const item = stepItems[i].shadowRoot.lastChild.childNodes[0];
            // remove old item selected class
            if (item.classList.contains("li-item--active")) {
                item.classList.remove("li-item--active");
            }
            // set active item class
            if (stepItems[i].innerText === targetItem) {
                item.classList.add("li-item--active");
            }
        }
    }
    resolveIcon() {
        if (this.iconSrc !== undefined) {
            return this.iconSrc;
        }
        return getAssetPath("step-list-item-assets/dot.svg");
    }
    render() {
        return (h(Host, { key: '4fefcac40dd9a36a9fc954ff49e377010a1db003', class: "item", style: { width: "100%" } }, h("li", { key: 'b4ad2cd516c44be5178c1bba4205296070f26350', class: {
            // "tree-open": this.opened,
            // disabled: this.disabled,
            } }, h("div", { key: '7cdc09fffd661a7fa9ef639fe279e7bbb5ce257b', class: {
                "li-item": true
                // "li-text--selected": this.selected,
            } }, h("span", { key: '0fbea41852135361d1d712abee8b957a7a2a506e', class: "text", onClick: () => this.itemClickedHandler(this) }, h("slot", { key: '123627bcc0a506d1fa2ad53b2a1709d4a9fc51c1' })), h("div", { key: '5abeac62fc8b1550b44fa3d2c104b36e8c61a0cc', class: "round-tab", onClick: () => this.itemClickedHandler(this) }, h("div", { key: '71d0098c09f02dc590a35cb79176604809cc7132', part: "item-icon" })), h("span", { key: 'e88681a435825bc56ec91429542a435591b67a4b', class: {
                "horizontal-line": true
            } })))));
    }
    static get is() { return "ch-step-list-item"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["ch-step-list-item.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["ch-step-list-item.css"]
        };
    }
    static get assetsDirs() { return ["step-list-item-assets"]; }
    static get properties() {
        return {
            "iconSrc": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Set the left side icon"
                },
                "attribute": "icon-src",
                "reflect": false
            }
        };
    }
    static get events() {
        return [{
                "method": "itemClicked",
                "name": "itemClicked",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "Emits the item id"
                },
                "complexType": {
                    "original": "any",
                    "resolved": "any",
                    "references": {}
                }
            }];
    }
    static get elementRef() { return "el"; }
}
